import React from "react";
import "./NielitPage.css";
import BannerImage from "../Component/Nielit.png"; // ✅ Replace with your actual image file name

const NielitPage = () => {
  return (
    <div className="nielit-page">
      {/* 🔹 Banner Section */}
      <div className="nielit-banner">
        <img src={BannerImage} alt="NIELIT Banner" className="banner-img" />
       
      </div>

      {/* 🔹 Content Section */}
      <div className="container py-5 nielit-content">
        <h2 className="text-primary fw-bold mb-4 text-center">
          About NIELIT (National Institute of Electronics & Information Technology)
        </h2>

        <p>
          The National Institute of Electronics & Information Technology (NIELIT) is an autonomous
          scientific society under the Ministry of Electronics and Information Technology (MeitY),
          Government of India. It plays a crucial role in promoting digital literacy and enhancing
          IT skills across the country. CPIT, as an accredited training partner of NIELIT, conducts
          various certification programs such as O-Level and CCC, designed to strengthen students’
          foundation in computer applications and digital technologies.
        </p>

        <p>
          NIELIT courses are recognized nationwide by both government and private sectors, making
          them highly valuable for students seeking jobs in IT, data management, programming, and
          office automation. The curriculum is continuously updated to match the evolving needs of
          the digital industry, ensuring students stay aligned with the latest technologies and
          software tools used in professional environments.
        </p>

        <p>
          At CPIT, our NIELIT-accredited programs focus on practical learning and hands-on
          experience. Students are trained in a lab-oriented environment with real-world examples,
          assignments, and projects. This approach not only helps them understand theoretical
          concepts but also builds problem-solving and technical implementation skills essential for
          future careers in information technology.
        </p>

        <p>
          Upon successful completion of NIELIT courses, students receive nationally recognized
          certificates that open doors to multiple career opportunities, including roles in data
          entry, office management, web development, and IT support. These programs are especially
          beneficial for individuals aiming to work in government departments, educational
          institutions, or private organizations where computer proficiency is a must.
        </p>
      </div>
    </div>
  );
};

export default NielitPage;
